import MESSAGE_MODEL from '../../../services/entity/message';
import { DEFAULT_EMPTY_VALUE } from '../../constants';
import { getItemOrDefaultToValue } from '../../details';
import { displayTime } from '../../time';

const transformMessagingList = data => {
  return data.map(item => {
    return {
      senderId: getItemOrDefaultToValue(
        item,
        MESSAGE_MODEL.senderId.id,
        DEFAULT_EMPTY_VALUE,
      ),
      recipientId: getItemOrDefaultToValue(
        item,
        MESSAGE_MODEL.recipientId.id,
        DEFAULT_EMPTY_VALUE,
      ),
      acknowledgedAt: getItemOrDefaultToValue(
        item,
        MESSAGE_MODEL.acknowledgedAt.id,
        DEFAULT_EMPTY_VALUE,
      ),
      id: item[MESSAGE_MODEL.id.id],
      senderName: getItemOrDefaultToValue(
        item,
        MESSAGE_MODEL.senderName.id,
        DEFAULT_EMPTY_VALUE,
      ),
      title: getItemOrDefaultToValue(
        item,
        MESSAGE_MODEL.title.id,
        DEFAULT_EMPTY_VALUE,
      ),
      body: getItemOrDefaultToValue(
        item,
        MESSAGE_MODEL.body.id,
        DEFAULT_EMPTY_VALUE,
      ),
      dateSent: item[MESSAGE_MODEL.sentAt.id]
        ? displayTime({ timestamp: item[MESSAGE_MODEL.sentAt.id] })
        : DEFAULT_EMPTY_VALUE,
      recipientName: getItemOrDefaultToValue(
        item,
        MESSAGE_MODEL.recipientName.id,
        DEFAULT_EMPTY_VALUE,
      ),
    };
  });
};

export default transformMessagingList;
